import api, { transformRequest, transformResponse } from "services/api";

export const lookupApi = api.enhanceEndpoints({ addTagTypes: [] }).injectEndpoints({
  endpoints: (build) => ({
    lookup: build.mutation({
      query: (payload) => ({
        url: `api/v1/consumer/auth/lookup/`,
        method: "POST",
        body: transformRequest(payload),
      }),
      transformResponse: (response) => transformResponse(response),
    }),
    getPaymentPortalConfigurations: build.query({
      query: (payload) => `/api/v1/consumer/portal-configurations/${payload.agencySlug}/payment/`,
      transformResponse: (response) => transformResponse(response),
    }),
  }),
});

export const { useLookupMutation, useGetPaymentPortalConfigurationsQuery } = lookupApi;
